import { IPlaylistDataDto, PlaylistPublicControllerClient } from '../clients/services';
import clientFactory from './client-factory';

const serviceUrl = (process.env.REACT_APP_SERVICE_URL as string | undefined)?.replace(/\/$/, '') ?? '';

export class PlaylistPublicService {
    private readonly playlistPublicClient: PlaylistPublicControllerClient;

    constructor() {
        this.playlistPublicClient = clientFactory.createClient(PlaylistPublicControllerClient);
    }

    async loadNewestPlaylistAsync(): Promise<IPlaylistDataDto> {
        return await this.playlistPublicClient.getNewestPlaylist();
    }

    async loadNewestThreePlaylistsAsync(): Promise<IPlaylistDataDto[]> {
        return await this.playlistPublicClient.getNewestThreePlaylists();
    }

    resolveImageUrl(rawUrl?: string | null): string {
        if (!rawUrl) {
            return '';
        }

        if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
            return rawUrl;
        }

        if (rawUrl.startsWith('/images/') || rawUrl.startsWith('images/')) {
            return rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;
        }

        const normalizedPath = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;
        if (!serviceUrl) {
            return normalizedPath;
        }

        return `${serviceUrl}${normalizedPath}`;
    }
}
